// Per-track-key tick counter. Bumped each tick a track appears in its PC's
// StatsGraph. The orchestrator uses the count to suppress scoring for the
// first WARMUP_TICKS observations of any track — `extract-track-fields`
// emits the cumulative-since-track-start as the "delta" on first observation,
// so per-tick bitrate/packet rates would be wildly inflated otherwise.
export class WarmupTracker {
  private observedTicksByTrackKey = new Map<string, number>();

  observe(key: string): number {
    const next = (this.observedTicksByTrackKey.get(key) ?? 0) + 1;
    this.observedTicksByTrackKey.set(key, next);
    return next;
  }

  // Drop counters for tracks not present in `seen`. A brief unsubscribe →
  // resubscribe replays warmup, matching the deltaOf "cumulative-as-delta on
  // first observation" semantics.
  evictUnseen(seen: ReadonlySet<string>): void {
    for (const key of this.observedTicksByTrackKey.keys()) {
      if (!seen.has(key)) {
        this.observedTicksByTrackKey.delete(key);
      }
    }
  }

  clear(): void {
    this.observedTicksByTrackKey.clear();
  }
}
